(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/components/menu.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/components/menu.js');
"use strict";

var _svs$eInstant$data$mo;
const _React = React,
  useMemo = _React.useMemo,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const _svs$ui$ReactItemsMen = svs.ui.ReactItemsMenu,
  ItemsMenu = _svs$ui$ReactItemsMen.ItemsMenu,
  IconItem = _svs$ui$ReactItemsMen.IconItem;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory,
  useLocation = _ReactRouterDOM.useLocation,
  matchPath = _ReactRouterDOM.matchPath;
const trackMenuClick = svs.eInstant.tracking.trackMenuClick;
const _svs$eInstant$constan = svs.eInstant.constants.ROUTES,
  PLAY = _svs$eInstant$constan.PLAY,
  DEMO_PLAY = _svs$eInstant$constan.DEMO_PLAY,
  BET_DETAIL = _svs$eInstant$constan.BET_DETAIL,
  CATEGORY = _svs$eInstant$constan.CATEGORY,
  INFO = _svs$eInstant$constan.INFO,
  ALL_GAMES = _svs$eInstant$constan.ALL_GAMES,
  FAVORITES = _svs$eInstant$constan.FAVORITES;
const menu = ((_svs$eInstant$data$mo = svs.eInstant.data.moduleConfig) === null || _svs$eInstant$data$mo === void 0 ? void 0 : _svs$eInstant$data$mo.menu) || [];
const getMenuItemType = item => {
  if (item.type.showHome !== undefined) {
    return {
      type: 'home',
      show: item.type.showHome
    };
  }
  if (item.type.showFavorites !== undefined) {
    return {
      type: 'favorites',
      show: item.type.showFavorites
    };
  }
  if (item.type.showAllGames !== undefined) {
    return {
      type: 'allGames',
      show: item.type.showAllGames
    };
  }
  if (item.type.showLink !== undefined) {
    return {
      type: 'link',
      show: item.type.showLink
    };
  }
  if (item.type.showCategory !== undefined) {
    return {
      type: 'category',
      show: item.type.showCategory
    };
  }
  svs.eInstant.logger.warn('Unknown menu item type', item);
  return {};
};
setGlobal('svs.eInstant.shared.components.Menu', () => {
  const history = useHistory();
  const location = useLocation();
  const menuItemsWrapperRef = useRef(null);
  const isPlayRoute = matchPath(location.pathname, {
    path: [PLAY, DEMO_PLAY, BET_DETAIL],
    exact: false
  });
  const isInfoMobile = matchPath(location.pathname, {
    path: [INFO],
    exact: false
  }) && svs.core.detect.formfactor.mobile();
  const categoryUrl = path => CATEGORY.replace(':categoryId', path);
  const menuItems = useMemo(() => menu.map(item => {
    const _getMenuItemType = getMenuItemType(item),
      type = _getMenuItemType.type,
      show = _getMenuItemType.show;
    if (!show) {
      return null;
    }
    switch (type) {
      case 'home':
        return {
          title: item.title || 'Start',
          icon: item.icon || 'nav-home',
          urlPaths: ['/', INFO]
        };
      case 'favorites':
        return {
          title: item.title || 'Favoriter',
          icon: item.icon || 'favorites',
          urlPaths: [FAVORITES, "".concat(FAVORITES).concat(INFO)],
          loginRequired: true
        };
      case 'allGames':
        return {
          title: item.title || 'Alla spel',
          icon: item.icon || 'games',
          urlPaths: [ALL_GAMES, "".concat(ALL_GAMES).concat(INFO)]
        };
      case 'link':
        return {
          title: item.title,
          icon: item.icon,
          urlPaths: [item.type.linkUrlPath, "".concat(item.type.linkUrlPath).concat(INFO)],
          loginRequired: item.type.linkLoginRequired,
          withinLobby: item.type.linkWithinLobby
        };
      case 'category':
        return {
          title: item.title,
          icon: item.icon,
          urlPaths: [categoryUrl(item.type.urlPath), "".concat(categoryUrl(item.type.urlPath)).concat(INFO)]
        };
      default:
        return null;
    }
  }).filter(item => item !== null), []);
  useEffect(() => {
    const onScroll = () => {
      const menuItems = document.querySelector('.js-items-menu-item');
      if (!menuItems) return;
      const iconHeight = menuItems.querySelector('.icon').parentElement; 
      const offset = menuItems.offsetHeight - iconHeight.offsetHeight;
      if (menuItemsWrapperRef.current) {
        menuItemsWrapperRef.current.style.setProperty('--itemMenuStickyOffset', "".concat(offset, "px"));
      }
    };
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);
  if (isPlayRoute || isInfoMobile) return null;
  const handleOnClick = function (e, url, title, loginRequired) {
    let withinLobby = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    e.preventDefault();
    trackMenuClick(title);
    if (loginRequired === true && !svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      svs.components.customer_login.login({
        returnUrl: withinLobby ? svs.core.data.baseUrl + url : url,
        returnNewCustomer: true
      });
      return;
    }
    if (withinLobby) {
      history.push(url);
    } else {
      window.location.pathname = url;
    }
  };
  return React.createElement("div", {
    className: "tickets-einstant-items-menu-wrapper",
    ref: menuItemsWrapperRef
  }, React.createElement(ItemsMenu, {
    centered: true,
    className: "tickets-einstant-items-menu",
    hiddenScrollbar: true,
    useScrollHelpers: true
  }, menuItems.map(_ref => {
    let title = _ref.title,
      icon = _ref.icon,
      urlPaths = _ref.urlPaths,
      loginRequired = _ref.loginRequired,
      withinLobby = _ref.withinLobby;
    return React.createElement(IconItem, {
      alignment: "vertical",
      Component: "a",
      gutter: 1,
      href: "#",
      iconName: icon,
      isSelected: Boolean(urlPaths.find(path => location.pathname.endsWith(path) || matchPath(location.pathname, {
        path,
        exact: true,
        strict: true
      }))),
      key: urlPaths[0],
      label: title,
      onClick: e => handleOnClick(e, urlPaths[0], title, loginRequired, withinLobby)
    });
  })));
});

 })(window);